module.exports = __webpack_public_path__ + "people_before.e56d59ec.png";